import { getSizedImageURL } from '../../core/images';

const findNextVariantImage = (variant) => {
  const product = window.theme.quickview.product;
  let variant_color = '';
  let next_color_image = '';
  for (let i = 0; i < product.variants.edges.length; i++) {
    const product_variant = product.variants.edges[i];

    if (product_variant.node.id === variant.id) {
      variant_color = variant.selectedOptions[0].value;
      continue;
    }

    if (variant_color !== '') {
      if (product_variant.node.selectedOptions[0].value !== variant_color) {
        next_color_image = (product_variant.node.image === null) ? '' : product_variant.node.image.url;
        break;
      }
    }
  }

  return next_color_image;
};

const getVariantImages = (product_images, variant_image, next_color_image) => {
  console.log(product_images, variant_image, next_color_image);
  const variant_images = [];

  let image_found = false;
  for (let i = 0; i < product_images.length; i++) {
    const product_image = product_images[i].node.url;

    if (product_image === variant_image) {
      image_found = true;
      variant_images.push(product_image);
      continue;
    }

    if (product_image === next_color_image) {
      break;
    }

    if (image_found) {
      variant_images.push(product_image);
    }
  }

  return variant_images;
};

export default (variant, total_images = 4) => {
  try {
    if (window.theme.quickview.product === null) {
      throw new Error('Missing product data');
    }
    
    const product_images = window.theme.quickview.product.images.edges;

    if (product_images === null || product_images.length === 0 || variant.image === null) {
      return '';
    }

    const next_color_image = findNextVariantImage(variant);
    const variant_images = getVariantImages(product_images, variant.image.url, next_color_image);
    console.log('variant_images', variant_images);

    let images_html = '';
    for (let i = 0; i < variant_images.length; i++) {
      if (i < total_images) {
        images_html += `<img class="product-main__image" src="${getSizedImageURL(variant_images[i], '500x')}" alt="${window.theme.quickview.product.title} - ${_.first(variant.title.split('/'))} - Image ${i + 1}" tabindex="0" />`;
      }
    }

    return `
      <div class="product-main" data-product-main>
        ${images_html}
      </div>
    `;
  } catch (error) {
    console.log('Product images error', error);
    return '';
  }
};
